module.exports = __webpack_public_path__ + "img/guanliyuan.db230c20.png";